import Navigator from 'app';
import MemberModel from './member_model';
const MemberCollection = Backbone.Collection.extend({
  model: MemberModel,
  url: Navigator.config.api_base + "members/",
  comparator: function (member) {
    return (member.get("district_type") === "House" ? 0 : 1000) + parseInt(member.get("district_number"));
  }
});
const API = {
  getMembers: function getMembers() {
    var defer = $.Deferred();
    if (!Navigator.members || Navigator.members.length == 0) {
      Navigator.members = new MemberCollection();
      Navigator.members.fetch({
        dataType: "json",
        success: function (data) {
          defer.resolve(data);
        }
      });
      return defer.promise();
    } else {
      return Navigator.members;
    }
  },
  getMembersForCounty: function getMembersForCounty(county) {
    var defer = $.Deferred();
    var members = new MemberCollection();
    members.url = Navigator.config.api_base + 'members/by_county/' + county;
    members.fetch({
      dataType: "json",
      success: function (data) {
        defer.resolve(data);
      }
    });
    return defer.promise();
  },
  getMembersByLastName: function getMembersByLastName(name) {
    var defer = $.Deferred();
    var members = new MemberCollection();
    members.url = Navigator.config.api_base + 'members/by_last_name/' + name;
    members.fetch({
      dataType: "json",
      success: function (data) {
        defer.resolve(data);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("member:list", function () {
  return API.getMembers();
});
Navigator.reqres.setHandler("members:county", function (county) {
  return API.getMembersForCounty(county);
});
Navigator.reqres.setHandler("members:lastname", function (name) {
  return API.getMembersByLastName(name);
});
export { MemberCollection as default };